<template>
	<img
		:src="computedUri"
		@click="openGLightBox"
		:class="{ allowZoom: allowZoom }"
		:alt="alt"
	/>
</template>

<script>
import GLightBox from "glightbox"; // https://github.com/biati-digital/glightbox
import axios from "axios";

require("glightbox/dist/css/glightbox.min.css");

export default {
	// props: ["comp", "alt"],
	name: 'ApiImgPristine',
	props: {
		size: {
			type: String,
			default: "auto",
		},
		comp: {
			type: [String, Number],
			default: null,
		},
		alt: {
			type: [String],
		},
		allowZoom: {
			type: [Boolean, Number, String],
			default: false,
		},
	},
	computed: {
		computedUri() {
			let r = null;
			if (
				this.comp != null &&
				this.comp != "" &&
				typeof parseInt(this.comp) == "number"
			) {
				switch (this.size) {
					case "auto":
						r =
							axios.defaults.maediaImageRender +
							this.comp +
							"/b-imgs.jpg";
						break;
					default:
						r =
							axios.defaults.maediaImageRender +
							this.comp +
							"/" +
							this.size +
							"/b-sized.jpg";
						break;
				}
				return r;
			} else {
				return "public/images/no-picture.png";
			}
		},
	},
	data: () => {
		return {
			lBox: null,
		};
	},
	methods: {
		openGLightBox() {
			if (this.allowZoom && this.allowZoom != "false" && !!this.comp) {
				this.lBox = new GLightBox();
				this.lBox.insertSlide({
					href: this.computedUri,
					type: "image",
				});
				this.lBox.open();
			} else {
				console.log(this.allowZoom);
			}
		},
	},
};
</script>

<style lang="less">
.glightbox-mobile .goverlay {
	background: hsla(0, 0%, 0%, 0.7) !important;
}

.gslide-image img {
	box-shadow: var(--ui-box-shadow);
}
</style>